import {
    serverBus
} from '@/main'
import Global from '@/scripts/Global';
import KeyboardManager from '@/Manager/keyboard.manager';
import DOMManager from '@/Manager/DOM.manager';
import VueSignals from '@/scripts/VueSignals';

import UploadFile from '@/components/SmallOverlay/UploadFile/UploadFile.vue';
import RenameFF from '@/components/SmallOverlay/RenameFF/RenameFF.vue';
import RemoveLicense from '@/components/SmallOverlay/RemoveLicense/RemoveLicense.vue';
import FolderCreate from '@/components/SmallOverlay/FolderCreate/FolderCreate.vue';
import ExternalLinks from '@/components/SmallOverlay/ExternalLinks/ExternalLinks.vue';
import DeniedNotification from '@/components/SmallOverlay/DeniedNotification/DeniedNotification.vue';
import DeleteUser from '@/components/SmallOverlay/DeleteUser/DeleteUser.vue';
import ConfirmDeleteFF from '@/components/SmallOverlay/ConfirmDeleteFF/ConfirmDeleteFF.vue';
import ConfirmCancelUpload from '@/components/SmallOverlay/ConfirmCancelUpload/ConfirmCancelUpload.vue';
import ConfirmDeleteMessage from '@/components/SmallOverlay/ConfirmDeleteMessage/ConfirmDeleteMessage.vue';
import ChannelPurpose from '@/components/SmallOverlay/ChannelPurpose/ChannelPurpose.vue';
import DeleteChannel from '@/components/SmallOverlay/DeleteChannel/DeleteChannel.vue';
import LeaveChannel from '@/components/SmallOverlay/LeaveChannel/LeaveChannel.vue';
import Search from '@/components/SmallOverlay/Search/Search.vue';
import UploadChannelPicture from '@/components/SmallOverlay/UploadChannelPicture/UploadChannelPicture.vue';
import ChooseCreateChannel from '@/components/SmallOverlay/ChooseCreateChannel/ChooseCreateChannel.vue';
import MediaModal from '@/components/SmallOverlay/MediaModal/MediaModal.vue';
import ChannelsArrangeTool from '@/components/SmallOverlay/ChannelsArrangeTool/ChannelsArrangeTool.vue';

export default {
    name: 'SmallOverlay',
    data() {
        return {
            showSmallModal: false,
            showSmallType: '',
            data: '',
        }
    },
    components: {
        FolderCreate,
        ChannelPurpose,
        ConfirmDeleteFF,
        RenameFF,
        UploadFile,
        LeaveChannel,
        DeleteChannel,
        DeleteUser,
        Search,
        ExternalLinks,
        RemoveLicense,
        DeniedNotification,
        ConfirmCancelUpload,
        ConfirmDeleteMessage,
        UploadChannelPicture,
        ChooseCreateChannel,
        MediaModal,
        ChannelsArrangeTool
    },
    mounted() {
        serverBus.$on(VueSignals.SHOW_SMALL_MODAL, (modalStatus) => {
            this.showSmallModal = modalStatus;
            if (modalStatus) {
                KeyboardManager.disableChatMode()
                this.ActivateClose()
            } else {
                // DOMManager.RebuildChatArea()
                // Global.globalValue(VueSignals.SEARCH_FEED_TEXT, '')
            }
        })

        serverBus.$on(VueSignals.SHOW_SMALL_MODAL_TYPE, (type) => {
            this.showSmallType = type
        });

        serverBus.$on(VueSignals.SMALL_OVERLAY_DATA, (data) => {
            this.data = data
        })
    },
    methods: {
        closeModal() {
            this.showSmallModal = false
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
            KeyboardManager.enableChatMode()
        },
        ActivateClose() {
            document.onmousedown = function(e) {
                if (e.target.classList.contains("modal-wrapper")) {
                    Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
                }
            }
            document.onkeyup = function(e) {
                if (e.key == "Escape") {
                    Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
                    KeyboardManager.enableChatMode()
                }
            }
        },
    }
}
